import { graphql } from 'react-relay';

export const pictureBlockFragment = graphql`
    fragment PictureBlock_contentBlock on PictureBlock {
        title
        url
        altText
    }
`;
